import { Box, CircularProgress } from "@mui/material";

import type { SxProps, Theme } from "@mui/material";

interface Props {
  children: React.ReactNode;
  loading: boolean;
  // Styles the wrapper around the loaded children, e.g. to keep a flex layout.
  sx?: SxProps<Theme>;
}

export function LoadingWrappedNode(props: Props) {
  const { children, loading, sx } = props;
  if (loading) {
    return (
      <Box
        id="loading-wrapped-component-spinner-container"
        display="flex"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box id="loading-wrapped-component" sx={sx}>
      {children}
    </Box>
  );
}
